import { Permission } from 'src/app/models/principal/permission';
import { Authority } from 'src/app/models/principal/authority';

/**
 * Map with permission and array with roles which has the permission to execute given operation.
 */
export const PERMISSIONS_MAP = {
  [Permission.CREATE_SANDBOX]: [Authority.SOLUTION_DEVELOPER, Authority.BSG, Authority.OPERATIONS_MANAGER, Authority.PROSPECT],

  [Permission.DEPLOY_CONFIG_INSTANCE]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],
  [Permission.UPDATE_CONFIG_INSTANCE]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],
  [Permission.TERMINATE_CONFIG_INSTANCE]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],

  [Permission.CONFIGURE_SERVICE]: [Authority.SOLUTION_DEVELOPER],
  [Permission.PUBLISH_CONFIG_PACK]: [Authority.SOLUTION_DEVELOPER],

  [Permission.UPLOAD_CRVT]: [],

  [Permission.UPGRADE_ENTERPRISE]: [Authority.PROSPECT, Authority.CHANGE_APPROVER],
  [Permission.CREATE_SERVICE_DEFINITION]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],
  [Permission.DELETE_SERVICE_DEFINITION]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],
  [Permission.UPDATE_SERVICE_DEFINITION]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],

  [Permission.VIEW_ENTERPRISE]: [Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER],
  [Permission.VIEW_ENTERPRISE_PROSPECT]: [Authority.PROSPECT],
  [Permission.VIEW_ENTERPRISE_SERVICE]: [Authority.READER, Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER,
    Authority.CHANGE_APPROVER],

  [Permission.DEPLOY_PTL_INSTANCE]: [Authority.OPERATIONS_MANAGER],
  [Permission.UPDATE_PTL_INSTANCE]: [Authority.OPERATIONS_MANAGER],
  [Permission.TERMINATE_PTL_INSTANCE]: [Authority.OPERATIONS_MANAGER],
  [Permission.UPDATE_SECRETS]: [Authority.OPERATIONS_MANAGER],

  [Permission.EDIT_PTL_WORKFLOW]: [Authority.OPERATIONS_MANAGER],
  [Permission.DEFINE_PTL_WORKFLOW]: [Authority.OPERATIONS_MANAGER],

  [Permission.VIEW_SETTINGS]: [Authority.OPERATIONS_MANAGER],
  [Permission.DOWNLOAD_IAC]: [Authority.IAC_READER],

  [Permission.SERVICES_SECTION] : [Authority.BSG, Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER, Authority.CHANGE_APPROVER,
    Authority.IAC_READER, Authority.READER],
  [Permission.RETRY]: [Authority.OPERATIONS_MANAGER],
  [Permission.NO_SERVICES]: [Authority.PROSPECT],
  [Permission.SERVICE_DEF_MENU]: [Authority.BSG, Authority.SOLUTION_DEVELOPER, Authority.OPERATIONS_MANAGER, Authority.CHANGE_APPROVER,
    Authority.IAC_READER, Authority.PROSPECT],

  [Permission.APPLY_RELEASE_PACKAGE]: [Authority.RELEASE_MANAGER, Authority.OPERATIONS_MANAGER],
  [Permission.APPLY_RELEASE_PACKAGE_HOTFIX]: [Authority.RELEASE_MANAGER],
  [Permission.APPLY_RELEASE_PACKAGE_TILL_TEST]: [Authority.SOLUTION_DEVELOPER],
  [Permission.CREATE_EXTEND_SERVICE]: [Authority.OPERATIONS_MANAGER, Authority.SOLUTION_DEVELOPER]
};
